module.exports = __webpack_public_path__ + "img/maninvan.532df539.png";